<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <keep-alive :include="[]">
        <router-view></router-view>
      </keep-alive>
    </transition>
  </section>
</template>

<script>

export default {
  name: 'AppMain',
  components: {
  },
  computed: {
    cachedViews () {
      return ['model'] // read from state
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/styles/variables.less";
.app-main {
  width: 1920px;
  // height: 100%;
  background-color: rgba(0,0,0,0);
}
</style>
